import mitt, { Emitter } from 'mitt';

type tGuideEmitter = Emitter<{
  'show-help': void;
  'show-help-qrcode': void;
  'show-template-guide': void;
  'hide-template-guide': void;
}>;

let guideMitter = undefined as tGuideEmitter | undefined;

export const getGuideEmitter = () => {
  return guideMitter || (guideMitter = mitt());
};
